import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberNotificationSettingsKey } from '../../utils/keys';
export const useMemberNotificationSettings = (options = {}) => {
    const { variables, useQueryOptions } = options || {};
    const { client } = useTribeClient();
    return useQuery(getMemberNotificationSettingsKey(variables), () => client.notifications.memberSettings(variables), useQueryOptions);
};
//# sourceMappingURL=useMemberNotificationSettings.js.map